(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["marevaka-hat-quiz"] && !Shopify.designMode) return;
  try {
    
class MarevakaHatQuiz extends HTMLElement {
  connectedCallback() {
    this.cancelAutoAdvance();
    this.abortController?.abort();
    this.abortController = new AbortController();
    this.questions = Array.from(this.querySelectorAll('[data-question]'));
    this.hats = Array.from(this.querySelectorAll('[data-hat]'));
    this.answers = {};
    this.currentStep = 0;
    this.arrowNavigation = false;
    this.form = this.querySelector('[data-quiz-form]');
    this.stage = this.querySelector('[data-stage]');
    this.launch = this.querySelector('[data-launch]');
    this.journey = this.querySelector('[data-journey]');
    this.results = this.querySelector('[data-results]');
    this.form?.reset();
    if (!this.hats.length) return;
    if (!this.questions.length) { this.showResults(false); return; }
    const options = { signal: this.abortController.signal };
    this.querySelectorAll('[data-controls]').forEach(control => { control.hidden = false; });
    this.querySelector('[data-start]').addEventListener('click', () => this.showQuestion(true), options);
    this.form.addEventListener('change', event => {
      const question = event.target.closest('[data-question]');
      if (!question || question !== this.questions[this.currentStep] || this.journey.hidden || !event.target.matches('input[type="radio"]')) return;
      this.answers[question.dataset.question] = event.target.value;
      this.updateNavigation();
    }, options);
    this.form.addEventListener('keydown', event => {
      this.arrowNavigation = event.target.matches('input[type="radio"]') && ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key);
      if (this.arrowNavigation) this.cancelAutoAdvance();
      if (event.target.matches('input[type="radio"]') && [' ', 'Enter'].includes(event.key)) {
        event.preventDefault();
        if (!event.repeat) event.target.click();
      }
    }, options);
    this.form.addEventListener('keyup', () => { this.arrowNavigation = false; }, options);
    this.form.addEventListener('click', event => {
      const question = event.target.closest('[data-question]');
      if (!question || question !== this.questions[this.currentStep] || this.journey.hidden || !event.target.matches('input[type="radio"]')) return;
      if (this.arrowNavigation && event.detail === 0) return;
      this.answers[question.dataset.question] = event.target.value;
      this.updateNavigation();
      this.cancelAutoAdvance();
      this.autoAdvanceTimer = window.setTimeout(() => {
        this.autoAdvanceTimer = null;
        if (question === this.questions[this.currentStep] && !this.journey.hidden) this.advance(false);
      }, 180);
    }, options);
    this.form.addEventListener('submit', event => { event.preventDefault(); this.advance(false); }, options);
    this.querySelector('[data-skip]').addEventListener('click', () => this.advance(true), options);
    this.querySelector('[data-back]').addEventListener('click', () => {
      if (this.currentStep > 0) { this.currentStep -= 1; this.showQuestion(true); }
    }, options);
    this.querySelector('[data-edit]').addEventListener('click', () => { this.currentStep = 0; this.showQuestion(true); }, options);
    this.querySelector('[data-restart]').addEventListener('click', () => {
      this.answers = {}; this.form.reset(); this.currentStep = 0; this.showQuestion(true);
    }, options);
    this.addEventListener('shopify:block:select', event => {
      const question = event.target.closest('[data-question]');
      if (question) { this.currentStep = this.questions.indexOf(question); this.showQuestion(false); }
      const hat = event.target.closest('[data-hat]');
      if (hat && window.Shopify?.designMode) {
        this.showResults(false);
        this.hats.forEach(card => { card.hidden = card !== hat; });
        this.style.setProperty('--mrv-result-columns', '1');
        this.querySelector('[data-products]').classList.add('mrv-hat-quiz__products--single');
      }
    }, options);
    this.updateNavigation();
    this.showLaunch();
  }

  disconnectedCallback() { this.cancelAutoAdvance(); this.abortController?.abort(); }

  cancelAutoAdvance() {
    window.clearTimeout(this.autoAdvanceTimer);
    this.autoAdvanceTimer = null;
  }

  showLaunch() {
    this.cancelAutoAdvance();
    this.stage.hidden = false;
    this.setPanelVisibility(this.launch, true);
    this.setPanelVisibility(this.journey, false);
    this.results.hidden = true;
  }

  setPanelVisibility(panel, visible) {
    if (!panel) return;
    panel.hidden = !visible;
    panel.toggleAttribute('inert', !visible);
    panel.setAttribute('aria-hidden', String(!visible));
  }

  updateNavigation() {
    const question = this.questions[this.currentStep];
    const isLast = this.currentStep === this.questions.length - 1;
    this.querySelector('[data-next]').disabled = !this.answers[question.dataset.question];
    this.querySelector('[data-next-label]').hidden = isLast;
    this.querySelector('[data-final-label]').hidden = !isLast;
    this.querySelector('[data-back]').hidden = this.currentStep === 0;
    this.querySelector('[data-progress-text]').textContent = this.dataset.progressTemplate
      .replace('[step]', String(this.currentStep + 1)).replace('[total]', String(this.questions.length));
    this.querySelector('[data-progress-bar]').style.width = `${(this.currentStep + 1) / this.questions.length * 100}%`;
  }

  showQuestion(focus) {
    this.cancelAutoAdvance();
    this.stage.hidden = false;
    this.setPanelVisibility(this.launch, false);
    this.results.hidden = true;
    this.setPanelVisibility(this.journey, true);
    this.questions.forEach((question, index) => { this.setPanelVisibility(question, index === this.currentStep); });
    this.updateNavigation();
    if (focus) this.focusView(this.questions[this.currentStep].querySelector('legend'));
  }

  advance(skip) {
    this.cancelAutoAdvance();
    if (this.journey.hidden) return;
    const question = this.questions[this.currentStep];
    if (skip) {
      delete this.answers[question.dataset.question];
      question.querySelectorAll('input').forEach(input => { input.checked = false; });
    } else if (!this.answers[question.dataset.question]) return;
    if (this.currentStep === this.questions.length - 1) this.showResults(true);
    else { this.currentStep += 1; this.showQuestion(true); }
  }

  rankHats() {
    const unique = new Map();
    this.hats.forEach((card, index) => {
      if (card.dataset.decorative === 'true') return;
      let score = 0;
      const matches = [];
      this.questions.forEach(question => {
        const answer = this.answers[question.dataset.question];
        const weight = Number(question.dataset.weight) || 0;
        if (!answer || weight <= 0) return;
        const rules = (card.getAttribute(`data-rule-${question.dataset.question}`) || '').split(',').filter(Boolean);
        if (rules.includes(answer)) {
          score += weight;
          matches.push(question.dataset.question);
        }
      });
      const entry = { card, score, matches, family: card.dataset.family || card.dataset.productId, available: card.dataset.available === 'true', priority: Number(card.dataset.priority) || 0, index };
      const key = card.dataset.productId;
      const previous = unique.get(key);
      if (!previous || score > previous.score || (score === previous.score && entry.priority > previous.priority)) unique.set(key, entry);
    });
    return Array.from(unique.values()).sort((a, b) => b.score - a.score || b.matches.length - a.matches.length || Number(b.available) - Number(a.available) || b.priority - a.priority || a.index - b.index);
  }

  selectHats(ranked) {
    const available = ranked.filter(entry => entry.available);
    const candidates = available.length ? available : ranked;
    if (!candidates.length) return [];
    const best = candidates[0];
    const winners = best.score > 0
      ? candidates.filter(entry => entry.score === best.score && entry.matches.length === best.matches.length)
      : candidates.slice(0, 1);
    const families = new Set();
    return winners.filter(entry => {
      if (families.has(entry.family)) return false;
      families.add(entry.family);
      return true;
    }).slice(0, 3);
  }

  answerLabel(question) {
    const answer = this.answers[question.dataset.question];
    const input = Array.from(question.querySelectorAll('input[type="radio"]')).find(option => option.value === answer);
    return input?.closest('label').querySelector('.mrv-hat-quiz__choice-label').textContent.trim() || '';
  }

  explainSelection(entry, ranked) {
    const matches = entry.card.querySelector('[data-match-list]');
    matches.replaceChildren();
    this.questions.forEach(question => {
      if (!entry.matches.includes(question.dataset.question)) return;
      const label = this.answerLabel(question);
      if (!label) return;
      const item = document.createElement('li');
      item.textContent = `${question.dataset.matchLabel} : ${label.toLocaleLowerCase()}`;
      matches.append(item);
    });
    entry.card.querySelector('[data-match-info]').hidden = !matches.children.length;
    const finishes = entry.card.querySelector('[data-finish-list]');
    finishes.replaceChildren();
    ranked.filter(other => other.card !== entry.card && other.family === entry.family && other.score === entry.score && other.matches.length === entry.matches.length).forEach(other => {
      const originalLink = other.card.querySelector('.h5 > a');
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = originalLink.href;
      link.textContent = originalLink.textContent.trim();
      const stock = other.card.querySelector('.mrv-hat-quiz__stock');
      if (!other.available && stock) link.textContent += ` · ${stock.textContent.trim()}`;
      item.append(link);
      finishes.append(item);
    });
    const finishesDisclosure = entry.card.querySelector('[data-finishes]');
    finishesDisclosure.hidden = !finishes.children.length;
    finishesDisclosure.open = false;
  }

  showResults(focus) {
    this.cancelAutoAdvance();
    this.stage.hidden = true;
    this.setPanelVisibility(this.launch, false);
    const ranked = this.rankHats();
    const selected = this.selectHats(ranked);
    const count = selected.length;
    this.hats.forEach(card => { card.hidden = true; });
    const products = this.querySelector('[data-products]');
    selected.forEach(entry => {
      this.explainSelection(entry, ranked);
      entry.card.hidden = false;
      products.append(entry.card);
    });
    products.classList.toggle('mrv-hat-quiz__products--single', count === 1);
    this.style.setProperty('--mrv-result-columns', String(Math.max(1, Math.min(3, count))));
    const intro = this.querySelector('[data-result-intro]');
    const hasAnswers = this.questions.some(question => this.answerLabel(question));
    intro.textContent = selected[0]?.score > 0 ? intro.dataset.personalized : hasAnswers ? intro.dataset.noMatch : intro.dataset.unanswered;
    const summary = this.querySelector('[data-answer-summary]');
    summary.replaceChildren();
    this.questions.forEach(question => {
      const label = this.answerLabel(question);
      if (!label) return;
      const chip = document.createElement('li');
      chip.textContent = label;
      summary.append(chip);
    });
    summary.hidden = !summary.children.length;
    const toneNote = this.querySelector('[data-tone-note]');
    if (toneNote) toneNote.hidden = !this.answers.tone;
    this.setPanelVisibility(this.journey, false);
    this.results.hidden = false;
    this.querySelector('[data-edit]').hidden = !this.questions.length;
    this.querySelector('[data-restart]').hidden = !this.questions.length;
    if (focus) this.focusView(this.querySelector('[data-result-heading]'));
  }

  focusView(target) {
    target.focus({ preventScroll: true });
    const header = document.querySelector('.shopify-section--header');
    const topInset = header ? Math.max(header.getBoundingClientRect().bottom, 0) : 0;
    const bounds = target.getBoundingClientRect();
    if (bounds.top < topInset + 12 || bounds.bottom > window.innerHeight - 24) {
      window.scrollBy({ top: bounds.top - topInset - 20, behavior: 'instant' });
    }
  }
}
if (!customElements.get('marevaka-hat-quiz')) customElements.define('marevaka-hat-quiz', MarevakaHatQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marevaka-home-journal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marevaka-journal-carousel')) {
    customElements.define('marevaka-journal-carousel', class extends HTMLElement {
      connectedCallback() {
        this.carousel = this.querySelector('scroll-carousel');
        this.previousButton = this.querySelector('carousel-prev-button button');
        this.nextButton = this.querySelector('carousel-next-button button');
        if (!this.carousel || !this.previousButton || !this.nextButton) return;
        this.abortController = new AbortController();
        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateControls());
        };
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.carousel);
        if (this.carousel.firstElementChild) this.resizeObserver.observe(this.carousel.firstElementChild);
        this.carousel.addEventListener('scroll', this.scheduleUpdate, {
          passive: true,
          signal: this.abortController.signal
        });
        ['scroll:edge-nearing', 'scroll:edge-leaving', 'carousel:settle'].forEach(eventName => {
          this.carousel.addEventListener(eventName, this.scheduleUpdate, {
            signal: this.abortController.signal
          });
        });
        customElements.whenDefined('scroll-carousel').then(() => {
          if (this.isConnected) this.scheduleUpdate();
        });
        this.scheduleUpdate();
      }

      updateControls() {
        if (!this.isConnected) return;
        const maximum = Math.max(0, this.carousel.scrollWidth - this.carousel.clientWidth);
        const position = Math.abs(this.carousel.scrollLeft);
        this.classList.toggle('has-overflow', maximum > 1);
        this.previousButton.disabled = maximum <= 1 || position <= 1;
        this.nextButton.disabled = maximum <= 1 || position >= maximum - 1;
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.abortController?.abort();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
